import { getLocales } from '@change-corgi/config/locales';
import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_HOMEPAGE_SUPPORT_AWARENESS = defineFcm('homepage_support_awareness')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				title: { type: 'string' },
				content: { type: 'string' },
				locales: {
					type: 'array',
					shape: {
						type: 'enum',
						values: getLocales('nonBeta'),
					},
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'TBD',
		context: 'homepage',
		description: 'Used to enable the support awareness component on the homepage.',
		import: false,
		template: {
			title: 'Our petition experts are waiting to support you',
			content:
				'Our team of petition experts are live now, ready to look at your petition and give you personalized advice over SMS.',
			locales: ['en-US'],
		},
	});
